/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../../spine/options_pb.js');
var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
goog.exportSymbol('proto.spine.server.entity.CannotModifyArchivedEntity', null, global);
goog.exportSymbol('proto.spine.server.entity.CannotModifyDeletedEntity', null, global);
goog.exportSymbol('proto.spine.server.entity.EntityAlreadyArchived', null, global);
goog.exportSymbol('proto.spine.server.entity.EntityAlreadyDeleted', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.server.entity.CannotModifyArchivedEntity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.server.entity.CannotModifyArchivedEntity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.server.entity.CannotModifyArchivedEntity.displayName = 'proto.spine.server.entity.CannotModifyArchivedEntity';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.server.entity.CannotModifyArchivedEntity.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.server.entity.CannotModifyArchivedEntity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.server.entity.CannotModifyArchivedEntity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.entity.CannotModifyArchivedEntity.toObject = function(includeInstance, msg) {
  var f, obj = {
    entityId: (f = msg.getEntityId()) && google_protobuf_any_pb.Any.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.server.entity.CannotModifyArchivedEntity}
 */
proto.spine.server.entity.CannotModifyArchivedEntity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.server.entity.CannotModifyArchivedEntity;
  return proto.spine.server.entity.CannotModifyArchivedEntity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.server.entity.CannotModifyArchivedEntity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.server.entity.CannotModifyArchivedEntity}
 */
proto.spine.server.entity.CannotModifyArchivedEntity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setEntityId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.server.entity.CannotModifyArchivedEntity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.server.entity.CannotModifyArchivedEntity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.server.entity.CannotModifyArchivedEntity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.entity.CannotModifyArchivedEntity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntityId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Any entity_id = 1;
 * @return {?proto.google.protobuf.Any}
 */
proto.spine.server.entity.CannotModifyArchivedEntity.prototype.getEntityId = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 1));
};


/** @param {?proto.google.protobuf.Any|undefined} value */
proto.spine.server.entity.CannotModifyArchivedEntity.prototype.setEntityId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.server.entity.CannotModifyArchivedEntity.prototype.clearEntityId = function() {
  this.setEntityId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.server.entity.CannotModifyArchivedEntity.prototype.hasEntityId = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.server.entity.CannotModifyDeletedEntity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.server.entity.CannotModifyDeletedEntity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.server.entity.CannotModifyDeletedEntity.displayName = 'proto.spine.server.entity.CannotModifyDeletedEntity';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.server.entity.CannotModifyDeletedEntity.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.server.entity.CannotModifyDeletedEntity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.server.entity.CannotModifyDeletedEntity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.entity.CannotModifyDeletedEntity.toObject = function(includeInstance, msg) {
  var f, obj = {
    entityId: (f = msg.getEntityId()) && google_protobuf_any_pb.Any.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.server.entity.CannotModifyDeletedEntity}
 */
proto.spine.server.entity.CannotModifyDeletedEntity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.server.entity.CannotModifyDeletedEntity;
  return proto.spine.server.entity.CannotModifyDeletedEntity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.server.entity.CannotModifyDeletedEntity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.server.entity.CannotModifyDeletedEntity}
 */
proto.spine.server.entity.CannotModifyDeletedEntity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setEntityId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.server.entity.CannotModifyDeletedEntity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.server.entity.CannotModifyDeletedEntity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.server.entity.CannotModifyDeletedEntity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.entity.CannotModifyDeletedEntity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntityId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Any entity_id = 1;
 * @return {?proto.google.protobuf.Any}
 */
proto.spine.server.entity.CannotModifyDeletedEntity.prototype.getEntityId = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 1));
};


/** @param {?proto.google.protobuf.Any|undefined} value */
proto.spine.server.entity.CannotModifyDeletedEntity.prototype.setEntityId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.server.entity.CannotModifyDeletedEntity.prototype.clearEntityId = function() {
  this.setEntityId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.server.entity.CannotModifyDeletedEntity.prototype.hasEntityId = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.server.entity.EntityAlreadyArchived = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.server.entity.EntityAlreadyArchived, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.server.entity.EntityAlreadyArchived.displayName = 'proto.spine.server.entity.EntityAlreadyArchived';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.server.entity.EntityAlreadyArchived.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.server.entity.EntityAlreadyArchived.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.server.entity.EntityAlreadyArchived} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.entity.EntityAlreadyArchived.toObject = function(includeInstance, msg) {
  var f, obj = {
    entityId: (f = msg.getEntityId()) && google_protobuf_any_pb.Any.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.server.entity.EntityAlreadyArchived}
 */
proto.spine.server.entity.EntityAlreadyArchived.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.server.entity.EntityAlreadyArchived;
  return proto.spine.server.entity.EntityAlreadyArchived.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.server.entity.EntityAlreadyArchived} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.server.entity.EntityAlreadyArchived}
 */
proto.spine.server.entity.EntityAlreadyArchived.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setEntityId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.server.entity.EntityAlreadyArchived.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.server.entity.EntityAlreadyArchived.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.server.entity.EntityAlreadyArchived} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.entity.EntityAlreadyArchived.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntityId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Any entity_id = 1;
 * @return {?proto.google.protobuf.Any}
 */
proto.spine.server.entity.EntityAlreadyArchived.prototype.getEntityId = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 1));
};


/** @param {?proto.google.protobuf.Any|undefined} value */
proto.spine.server.entity.EntityAlreadyArchived.prototype.setEntityId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.server.entity.EntityAlreadyArchived.prototype.clearEntityId = function() {
  this.setEntityId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.server.entity.EntityAlreadyArchived.prototype.hasEntityId = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.server.entity.EntityAlreadyDeleted = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.server.entity.EntityAlreadyDeleted, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.server.entity.EntityAlreadyDeleted.displayName = 'proto.spine.server.entity.EntityAlreadyDeleted';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.server.entity.EntityAlreadyDeleted.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.server.entity.EntityAlreadyDeleted.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.server.entity.EntityAlreadyDeleted} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.entity.EntityAlreadyDeleted.toObject = function(includeInstance, msg) {
  var f, obj = {
    entityId: (f = msg.getEntityId()) && google_protobuf_any_pb.Any.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.server.entity.EntityAlreadyDeleted}
 */
proto.spine.server.entity.EntityAlreadyDeleted.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.server.entity.EntityAlreadyDeleted;
  return proto.spine.server.entity.EntityAlreadyDeleted.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.server.entity.EntityAlreadyDeleted} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.server.entity.EntityAlreadyDeleted}
 */
proto.spine.server.entity.EntityAlreadyDeleted.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setEntityId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.server.entity.EntityAlreadyDeleted.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.server.entity.EntityAlreadyDeleted.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.server.entity.EntityAlreadyDeleted} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.entity.EntityAlreadyDeleted.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntityId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Any entity_id = 1;
 * @return {?proto.google.protobuf.Any}
 */
proto.spine.server.entity.EntityAlreadyDeleted.prototype.getEntityId = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 1));
};


/** @param {?proto.google.protobuf.Any|undefined} value */
proto.spine.server.entity.EntityAlreadyDeleted.prototype.setEntityId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.server.entity.EntityAlreadyDeleted.prototype.clearEntityId = function() {
  this.setEntityId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.server.entity.EntityAlreadyDeleted.prototype.hasEntityId = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.spine.server.entity);

// The code for parsing the Protobuf messages of this file from the JSON data.

let known_type_parsers = require('../../../known_type_parsers.js');

proto.spine.server.entity.CannotModifyArchivedEntity.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.server.entity.CannotModifyArchivedEntity.fromObject(jsObject);
};

proto.spine.server.entity.CannotModifyArchivedEntity.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.server.entity.CannotModifyArchivedEntity();
  
  if (obj.entityId !== undefined) {
    if (obj.entityId === null) {
      msg.setEntityId(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Any');
      let value = parser.parse(obj.entityId);
      msg.setEntityId(value);
    }
  }
  return msg;
};

proto.spine.server.entity.CannotModifyDeletedEntity.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.server.entity.CannotModifyDeletedEntity.fromObject(jsObject);
};

proto.spine.server.entity.CannotModifyDeletedEntity.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.server.entity.CannotModifyDeletedEntity();
  
  if (obj.entityId !== undefined) {
    if (obj.entityId === null) {
      msg.setEntityId(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Any');
      let value = parser.parse(obj.entityId);
      msg.setEntityId(value);
    }
  }
  return msg;
};

proto.spine.server.entity.EntityAlreadyArchived.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.server.entity.EntityAlreadyArchived.fromObject(jsObject);
};

proto.spine.server.entity.EntityAlreadyArchived.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.server.entity.EntityAlreadyArchived();
  
  if (obj.entityId !== undefined) {
    if (obj.entityId === null) {
      msg.setEntityId(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Any');
      let value = parser.parse(obj.entityId);
      msg.setEntityId(value);
    }
  }
  return msg;
};

proto.spine.server.entity.EntityAlreadyDeleted.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.server.entity.EntityAlreadyDeleted.fromObject(jsObject);
};

proto.spine.server.entity.EntityAlreadyDeleted.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.server.entity.EntityAlreadyDeleted();
  
  if (obj.entityId !== undefined) {
    if (obj.entityId === null) {
      msg.setEntityId(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Any');
      let value = parser.parse(obj.entityId);
      msg.setEntityId(value);
    }
  }
  return msg;
};
